// external imports
import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { SensorObject } from 'src/app/asp/SensorObject';
import * as utils from '../common/utils';
import { Animations } from '../Animations';
import { AnalysisInfo, VideoMsgMngrService } from '@core_n/msg/video-mngr.service';
import { Subscription } from 'rxjs';
import { aspMngr } from '@core_n/asp/AspMngr';
import { SensorsCorePool } from '@core_n/asp/SensorsCorePool';
import { ObjectType } from '@core_n/asp/AspObject';
import { mainMapMngr } from '@core_n/asp/MapMngr';
import { AppInjector } from '@core_n/common/inject';
import { AroSensorService } from 'src/app/aro/aro-sensor.service';
import { AppConfig } from '@core_n/app.config';
import { AnalyticsMngrService } from '@core_n/msg/analytics-mngr.service';
import { dialogType } from '@core_n/enums';

@Component({
  selector: 'analysisboard-window',
  templateUrl: './analysisBoard.component.html',
  styleUrls: ['./analysisBoard.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})

export class AnalysisBoardComponent extends ZIndexMngr implements OnInit, OnDestroy {

  public cameras: AnalysisInfo[] = [];
  // sub
  private camerasSub!: Subscription;

  constructor(public dialogRef: MatDialogRef<AnalysisBoardComponent>,
    elementRef: ElementRef,
    protected videomngr: VideoMsgMngrService,
    public analyticsMngrService: AnalyticsMngrService
  ) {
    super(elementRef);

    this.videomngr.updateAnalysisList();

    this.camerasSub! = this.videomngr.VideosInAnalysis$.subscribe(arr => {
      this.cameras = arr;
    })
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.camerasSub.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
      this.dialogRaise();
    })
  }

  static createDialogConfig() {
    return utils.createDialogConfig(false, false, dialogType.AnalysisWindow,
      { top: `${100}px`, right: `80px` });
  }

  setCenter(cameraName: string) {
    const sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get(cameraName.toLowerCase());
    mainMapMngr.setMapCenter(sensor.geometry);
  }

  openAro(cameraName: string) {
    const sensor = (aspMngr.getObjectsPool(ObjectType.Sensor) as SensorsCorePool).name2Obj.get(cameraName.toLowerCase());
    AppInjector.get(AroSensorService).showWindow(sensor as SensorObject);
  }

  removeCamera(cameraName: string) {
     try {
    
        this.videomngr.updateVideoAnalysisState(cameraName, "", false);
      }
      catch (e) {
        console.error("cannot send videomngr update: " + e);
      }
      finally {
        setTimeout(() => {
          try {
            this.analyticsMngrService.sendAnalticsRequest(cameraName, "", false);
          }
          catch (e) {
            console.error("cannot remove camera from analysis: " + e);
          }
        }, false ? AppConfig.settings.analysisAddress.delay : 1000);
      }
  }  
}